import { render, staticRenderFns } from "./exoneracoesRegularizadas.vue?vue&type=template&id=7fbfb118"
import script from "./exoneracoesRegularizadas.vue?vue&type=script&lang=js"
export * from "./exoneracoesRegularizadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports